export default __webpack_public_path__ + "static/media/mol1.05a131bd.gif";